import { render, staticRenderFns } from "./AntdButton.vue?vue&type=template&id=55111d6d&scoped=true&"
import script from "./AntdButton.vue?vue&type=script&lang=js&"
export * from "./AntdButton.vue?vue&type=script&lang=js&"
import style0 from "./AntdButton.vue?vue&type=style&index=0&id=55111d6d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55111d6d",
  null
  
)

export default component.exports